import {
    AEO_CAMPAIGN_CONFIG,
    AEO_PROMO_CODES,
    AEO_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL,
} from "app/components/AeoCampaignModal/configs/aeoCampaignConfig";
import type { AeoCampaignType } from "app/components/AeoCampaignModal/utils/campaignTypes";
import { getAeoCampaignType, isAeoCampaignEligible } from "app/components/AeoCampaignModal/utils/campaignTypes";
import type { IDiscountCampaignConfig } from "app/components/discountCampaign/DiscountBanner/types/discountCampaignConfig";
import { mergeDiscountDateConfig } from "app/components/discountCampaign/DiscountBanner/utils/discountConfig";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";

export const AeoDiscountGbEndDate = GrowthbookService.growthbookInstance.getFeatureValue(
    TestsNames.AEO_CAMPAIGN,
    "2026-01-01",
);

export const AEO_CAMPAIGN_ID = "aeo";

export const buildAeoDiscountCampaignConfig = (): IDiscountCampaignConfig<AeoCampaignType> => ({
    id: AEO_CAMPAIGN_ID,
    getCampaignType: getAeoCampaignType,
    getDiscountDateConfig: (campaignType) =>
        mergeDiscountDateConfig({
            base: AEO_CAMPAIGN_CONFIG[campaignType].discountConfig,
            gbDiscountEndDate: AeoDiscountGbEndDate,
        }),
    isEligible: isAeoCampaignEligible,
    annualPromoCodes: AEO_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL,
    getBannerConfig: (campaignType) => AEO_CAMPAIGN_CONFIG[campaignType].banner,
    getModalConfig: (campaignType) => AEO_CAMPAIGN_CONFIG[campaignType].modal,
    getPromoCode: (campaignType) => AEO_PROMO_CODES[campaignType],
});
